<template lang="">
  <div class="chart-box">
    <div class="select-box">
      <el-select
        v-model="selectVal"
        placeholder="请选择"
        :popper-class="'select_type_pzgmfx'"
        @change="changeYear"
      >
        <el-option
          v-for="item in options"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>
    <div class="tab-box flex">
      <div
        v-for="(item, index) in typeList"
        :key="index"
        class="tab-item"
        :class="{ active: active === index }"
        @click="changeType(index, item)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="chart" ref="ageChart"></div>
  </div>
</template>

<script>
import { loadAgeChart } from "../charts/xszbData";
import { timerMixin } from "@/util/mixin/timerMixin";
import { getVarietyScaleAnalysis } from "@/api/cyzl";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["种植面积", "年产量"],
      active: 0,
      selectVal: "2024",
      options: ["2024", "2023"],
      bfList: [] //保存指定年份下所有数据
    };
  },
  mounted() {
    this.getData();
    // this.getEchartsData();
    this.startTimer();
  },
  methods: {
    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeYear() {
      this.active = 0;
      this.getData();
    },
    changeType(index, clearT = true) {
      this.active = index;
      // this.getEchartsData();
      this.initChart();
      if (clearT) {
        this.startTimer();
      }
    },
    getData() {
      if (this.selectVal) {
        getVarietyScaleAnalysis({ year: this.selectVal }).then(res => {
          if (res) {
            let areaList = [];
            let clList = [];
            res.data.forEach(ele => {
              areaList.push({
                name: ele.name,
                value: ele.area
              });
              clList.push({
                name: ele.name,
                value: ele.cl
              });
            });
            this.bfList = [];
            this.bfList.push(areaList);
            this.bfList.push(clList);

            this.initChart();
            this.startTimer();
          }
        });
      }
    },
    initChart() {
      this.agechart = this.$echarts.init(this.$refs.ageChart);
      const bfData = this.bfList[this.active];
      const unitArr = ["万亩", "万吨"];
      const name = this.typeList[this.active];
      const unit = unitArr[this.active];
      loadAgeChart(this.agechart, bfData, name, unit, ""); //备注：茂名主要品种
    }

    // getEchartsData() {
    //   // 种植种类占比
    //   this.agechart = this.$echarts.init(this.$refs.ageChart);
    //   const resultArr = [
    //     [
    //       {
    //         name: "妃子笑",
    //         value: "16.47"
    //       },
    //       {
    //         name: "无核荔",
    //         value: "0.31"
    //       },
    //       {
    //         name: "桂味",
    //         value: "10.47"
    //       },
    //       {
    //         name: "白糖罂",
    //         value: "12.09"
    //       },
    //       {
    //         name: "白蜡",
    //         value: "13.03"
    //       },
    //       {
    //         name: "糯米糍",
    //         value: "4.03"
    //       },
    //       {
    //         name: "进奉",
    //         value: "3.82"
    //       },
    //       {
    //         name: "鸡嘴荔",
    //         value: "1.68"
    //       },
    //       {
    //         name: "黑叶",
    //         value: "38.10"
    //       }
    //     ],
    //     [
    //       {
    //         name: "妃子笑",
    //         value: "20.90"
    //       },
    //       {
    //         name: "无核荔",
    //         value: "0.66"
    //       },
    //       {
    //         name: "桂味",
    //         value: "9.92"
    //       },
    //       {
    //         name: "白糖罂",
    //         value: "12.03"
    //       },
    //       {
    //         name: "白蜡",
    //         value: "15.41"
    //       },
    //       {
    //         name: "糯米糍",
    //         value: "3.39"
    //       },
    //       {
    //         name: "进奉",
    //         value: "3.19"
    //       },
    //       {
    //         name: "鸡嘴荔",
    //         value: "1.81"
    //       },
    //       {
    //         name: "黑叶",
    //         value: "32.70"
    //       }
    //     ],
    //     [
    //       {
    //         name: "妃子笑",
    //         value: "2139"
    //       },
    //       {
    //         name: "无核荔",
    //         value: "1345"
    //       },
    //       {
    //         name: "桂味",
    //         value: "1456"
    //       },
    //       {
    //         name: "白糖罂",
    //         value: "1890"
    //       },
    //       {
    //         name: "白蜡",
    //         value: "1298"
    //       },
    //       {
    //         name: "糯米糍",
    //         value: "405"
    //       },
    //       {
    //         name: "进奉",
    //         value: "382"
    //       },
    //       {
    //         name: "鸡嘴荔",
    //         value: "168"
    //       },
    //       {
    //         name: "黑叶",
    //         value: "3420"
    //       }
    //     ]
    //   ];
    //   const bfData = resultArr[this.active];
    //   const unitArr = ["万亩", "万吨", "万元"];
    //   const name = this.typeList[this.active];
    //   const unit = unitArr[this.active];
    //   loadAgeChart(this.agechart, bfData, name, unit);
    // }
  }
};
</script>

<style lang="stylus" scoped>
.chart-box
  width 100%
  height 100%
  position relative
  .tab-box
    position absolute
    top 5px
    right 7%
    // right 4%
    z-index 999
    .tab-item
      color #fff
      font-size 10px
      padding-left 13px
      margin-right 20px
      position relative
      cursor pointer
      &:before
        content ' '
        // width 6px
        // height 6px
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
    .active
      color #0e9cff
      &:before
        background #0e9cff
  .select-box
    width 90px
    height 30px
    position absolute
    // top -18%
    // right 20%
    top -13%
    right 19%
  /deep/.el-input__inner
    font-size 13px
    height 26px
    line-height 26px
    color #fff
    background-color #014555
  /deep/.el-input__icon
    line-height 26px
  /deep/.el-select-dropdown__item
    color #00d0e8
    font-weight 500
</style>
<style>
.select_type_pzgmfx {
  background-color: #012032 !important;
}
.select_type_pzgmfx .el-select-dropdown__item {
  color: #00d0e8 !important;
}
.select_type_pzgmfx .el-select-dropdown__item.selected {
  color: rgb(252, 216, 52) !important;
}
.select_type_pzgmfx .el-select-dropdown__item.hover,
.select_type_pzgmfx .el-select-dropdown__item:hover {
  background-color: #0f7399 !important;
}
</style>
